<template>
	<div class="flex flex-col p-8">
		<div class="flex w-full gap-4">
			<div class="flex flex-col w-[25%] gap-2">
				<MultiSelect
					v-model="fazendasEscolhidas"
					class="max-w-1/2"
					:label="$t('farm')"
					:options="fazendas"
				/>
				<DatePickerRange
					v-model="dateRange"
					:label="$t('exportRange')"
					@click="formataDatas"
				/>
			</div>

			<div class="flex flex-col w-[25%] gap-2">
				<MultiSelect
					v-model="inventariosEscolhidos"
					:label="$t('forestStratification')"
					:options="estratos"
				/>
				<Checkbox
					v-model="selectMac"
					:label="$t('includeMacExp')"
				/>
			</div>
		</div>
		<Button
			style="margin-left: auto !important; margin-right: 20px !important"
			:label="$t('export')"
			color="trv-default"
			semantic-class="tiny"
			width-auto
			@click="exportar"
		/>
	</div>
</template>

<script>
import Button from '../../../components/Button/Button'
import Checkbox from '../../../components/Checkbox/Checkbox.vue'
import DatePickerRange from '../../../components/DatePickerRange/DatePickerRange.vue'
import MultiSelect from '../../../components/MultiSelect/MultiSelect'
import moment from 'moment'

import {
	getAmostraCsv,
	getDropdownSingleTrees,
} from '../../../services/requests/ExportacaoRequests.js'

export default {
	components: {
		Button,
		MultiSelect,
		Checkbox,
		DatePickerRange,
	},

	data() {
		return {
			dropdown: [],
			fazendasEscolhidas: [],
			inventariosEscolhidos: [],
			selectMac: false,
			dateRange: null,
			dataInicial: null,
			dataFinal: null,
		}
	},
	computed: {
		fazendas() {
			return this.dropdown.map((m) => {
				return Object.assign(m, { label: m.fazenda, value: m.fazendaId })
			})
		},
		estratos() {
			const estratos = []
			const fazendas = this.dropdown.filter((f) => this.fazendasEscolhidas.includes(f.fazendaId))
			fazendas.forEach((el) => {
				el.estratos.forEach((elm) => {
					elm.value = elm.estratoFlorestalId
					elm.label = elm.descricao
					estratos.push(elm)
				})
			})
			console.log(estratos)
			return estratos
			// return .reduce((a, b) => [].concat(a.processamentos).concat(b.processamentos), { processamentos: [] }).map(m => { return Object.assign(m, {label: m.descricao, value: m.estratoInventarioFlorestalId })})
		},
		dadoFormatado() {
			return {
				TipoExportacao: 'Default',
				estratoFlorestal: this.estratos.filter((f) =>
					this.inventariosEscolhidos.includes(f.estratoFlorestalId),
				),
				DataInicial: this.dataInicial,
				DataFinal: this.dataFinal,
				AdicionarMac: this.selectMac,
			}
		},
	},

	watch: {
		// Este watcher será chamado sempre que `dateRange` for alterado
		dateRange() {
			this.formataDatas()
		},
	},
	async created() {
		const response = await getDropdownSingleTrees()
		console.log('🚀 ~ file: InventarioArvore.vue ~ line 59 ~ created ~ response', response)
		this.dropdown = response.data.result
	},
	methods: {
		async exportar() {
			const response = await getAmostraCsv(this.dadoFormatado)
			var a = document.createElement('a')
			a.target = '_blank'
			a.href = response.data.message
			document.body.appendChild(a)
			a.click()
			document.body.removeChild(a)
			console.log('🚀 ~ file: InventarioArvore.vue ~ line 68 ~ export ~ response', response)
		},
		formataDatas() {
			let startDate = this.dateRange.start
			let endDate = this.dateRange.end

			// Converte as datas para o formato 'DD/MM/AAAA'
			let formattedStartDate = moment(startDate).format('DD/MM/YYYY')
			let formattedEndDate = moment(endDate).format('DD/MM/YYYY')
			// Converte as datas formatadas para objetos Date
			let dateObjectStart = moment(formattedStartDate, 'DD/MM/YYYY').toDate()
			let dateObjectEnd = moment(formattedEndDate, 'DD/MM/YYYY').toDate()
			this.dataInicial = dateObjectStart
			this.dataFinal = dateObjectEnd
		},
	},
}
</script>

<style scoped src="../../../css/crud.css"></style>
